"use client"

import * as React from "react"

import { InfoCircle } from "../../icons"
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "./tooltip"
import { tooltipContent, tooltipTrigger } from "./tooltip.styled"

type InfoTooltipProps = {
  content: string
  iconColor?: string
}

export const InfoTooltip = ({ content, iconColor }: InfoTooltipProps) => {
  const [isOpen, setIsOpen] = React.useState(false)

  return (
    <TooltipProvider>
      <Tooltip open={isOpen} onOpenChange={setIsOpen}>
        <TooltipTrigger
          type="button"
          className={tooltipTrigger}
          onMouseEnter={() => setIsOpen(true)}
          onMouseLeave={() => setIsOpen(false)}
          onFocus={() => setIsOpen(true)}
          onBlur={() => setIsOpen(false)}
          onTouchStart={() => setIsOpen((v) => !v)}
        >
          <InfoCircle color={iconColor} />
        </TooltipTrigger>
        <TooltipContent side="bottom">
          <p className={tooltipContent}>{content}</p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  )
}
